import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import {
  FaCheckCircle,
  FaClock,
  FaMoneyBill,
  FaSyncAlt,
  FaTimes
} from "react-icons/fa"

import { Button } from "components"
import { verifyOrderGatewayPayment } from "services"
import classes from "./OhStatus.module.scss"

const OhStatus = props => {
  const { order, readOnly, setOrders } = props

  const [t] = useTranslation()
  const [checking, setChecking] = useState(false)
  const [verificationResult, setVerificationResult] = useState("")

  const supportedPaymentTypes = [
    "zarinpal",
    "sadad",
    "pna",
    "haghighi_a2a"
  ]

  const showVerifyPayment =
    !readOnly &&
    order.orderStatus === "pending"

  const isPaymentTypeSupported =
    supportedPaymentTypes.includes(order.paymentType)

  const handleVerifyPayment = async () => {
    if (checking || !isPaymentTypeSupported) return

    setChecking(true)
    setVerificationResult("")

    try {
      const branchId = order.branchId?._id || order.branchId
      const result = await verifyOrderGatewayPayment(order._id, branchId)

      if (result.orderNeedsReconciliation) {
        setVerificationResult("پرداخت در سامانه ثبت شده است، اما وضعیت سفارش نیاز به بررسی فنی دارد.")
        toast.warning("پرداخت ثبت شده است؛ وضعیت سفارش نیاز به بررسی فنی دارد")
        return
      }

      if (result.paid) {
        setVerificationResult("پرداخت توسط درگاه تأیید شد و وضعیت سفارش به پرداخت‌شده تغییر کرد.")
        toast.success("پرداخت سفارش با موفقیت تأیید شد")
        setOrders?.(previous => previous.map(item => (
          item._id === order._id
            ? { ...item, orderStatus: "paid", paymentType: result.paymentType || item.paymentType }
            : item
        )))
      } else {
        setVerificationResult("درگاه پرداختی برای این سفارش تأیید نکرد.")
        toast.info("پرداخت این سفارش هنوز توسط درگاه تأیید نشده است")
      }
    } catch (error) {
      const message = error.response?.data?.message
      setVerificationResult("بررسی پرداخت انجام نشد. کمی بعد دوباره تلاش کنید.")
      toast.error(message || "امکان بررسی وضعیت پرداخت وجود ندارد")
    } finally {
      setChecking(false)
    }
  }

  return (
    <div className={classes["status-wrap"]}>
      <div className={classes["status"]}>
      <span className={classes["text"]}>
        {t("وضعیت_سفارش")}:
      </span>
      {
        order.orderStatus === "notConfirmed" &&
        <div className={classes["tag-pending"]}>
          <FaClock />
          <div>{t("در_انتظار_تایید")}</div>
        </div>
      }
      {
        order.orderStatus === "pending" &&
        <div className={classes["tag-pending"]}>
          <FaMoneyBill />
          <div>{t("پرداخت_نشده")}</div>
        </div>
      }
      {
        order.orderStatus === "paid" &&
        <div className={classes["tag-paid"]}>
          <FaMoneyBill />
          <div>{t("پرداخت_شده")}</div>
        </div>
      }
      {
        order.orderStatus === "delivered" &&
        <div className={classes["tag-completed"]}>
          <FaCheckCircle />
          <div>{t("تکمیل_شده")}</div>
        </div>
      }
      {
        order.orderStatus === "canceled" &&
        <div className={classes["tag-canceled"]}>
          <FaTimes />
          <div>{t("لغو_شده")}</div>
        </div>
      }
      {showVerifyPayment && (
        <Button
          className={classes["verify-button"]}
          variant="outline"
          color="primary"
          disabled={!isPaymentTypeSupported}
          loading={checking}
          onClick={handleVerifyPayment}
        >
          <FaSyncAlt />
          بررسی پرداخت
        </Button>
      )}
      </div>
      {verificationResult && (
        <div className={classes["verification-result"]}>
          {verificationResult}
        </div>
      )}
    </div>
  )
}

export default OhStatus
